export enum SkillId {
  MOBILITE_URBAINE = 'mobilité_urbaine',
  SERVICE_URBAIN = 'service_urbain',
  GESTION_INFRA = 'gestion_infra',
  INGENIERIE = 'ingénierie',
  MECENAT_ET_ACTIONS_CULTURELLES = 'mécénat_et_actions_culturelles',
  RSE = 'rse',
  INNOVATION = 'innovation',
  RATP_DEV = 'ratp_dev',
  CAP_IDF = 'cap_idf',
  SOLUTIONS_VILLE = 'solutions_ville',
  RATP_SMART_SYSTEMS = 'ratp_smart_systems',
  RATP_TRAVEL_RETAIL = 'ratp_travel_retail',
  FONDATION_GROUPE_RATP = 'fondation_groupe_ratp',
  RATP_SECURITE_EXPERTISES = 'ratp_sécurité_expertises',
  RATP_MAINTENANCE_SERVICES = 'ratp_maintenance_services',
  RATP_CONSULTING = 'ratp_consulting'
}

export enum KeywordId {
  CHAT = 'chat',
  CHIEN = 'chien',
  OISEAU = 'oiseau'
}

export enum SubsidiaryId {
  RATP_DEV = 'dev',
  RATP_CAP_IDF = 'cap_idf',
  RATP_SMART_SYSTEMS = 'ratp_smart_systems',
  RATP_TRAVEL_RETAIL = 'ratp_travel_retail',
  FONDATION_GROUPE_RATP = 'fondation_groupe_ratp',
  RATP_SECURITE_EXPERTISES = 'ratp_sécurité_expertises',
  RATP_MAINTENANCE_SERVICES = 'ratp_maintenance_services',
  RATP_CONSULTING = 'ratp_consulting'
}

export enum BgTwColor {
  WHITE = 'bg-white',
  RATP_OR = 'bg-ratp-or',
  PRIMARY = 'bg-primary',
  SECONDARY = 'bg-secondary',
  /* Première rangée */
  RATP_CIEL = 'bg-ratp-ciel',
  RATP_VERT_DEAU = 'bg-ratp-vert-deau',
  RATP_ANIS = 'bg-ratp-anis',
  RATP_TURQUOISE = 'bg-ratp-turquoise',
  /* Deuxième rangée */
  RATP_ROSE_CLAIR = 'bg-ratp-rose-clair',
  RATP_ORANGE_CLAIR = 'bg-ratp-orange-clair',
  RATP_MENTHE = 'bg-ratp-menthe',
  RATP_VERT = 'bg-ratp-vert',
  RATP_SAPIN = 'bg-ratp-sapin',
  /* Troisième rangée */
  RATP_ROSE_FONCE = 'bg-ratp-rose-fonce',
  RATP_FRAMBOISE = 'bg-ratp-framboise',
  RATP_ORANGE_FONCE = 'bg-ratp-orange-fonce',
  RATP_PRALINE = 'bg-ratp-praline'
}

export enum TextTwColor {
  WHITE = 'text-white',
  BLACK = 'text-black',
  PRIMARY = 'text-primary',
  SECONDARY = 'text-secondary',
  /* Première rangée */
  RATP_CIEL = 'text-ratp-ciel',
  RATP_VERT_DEAU = 'text-ratp-vert-deau',
  RATP_ANIS = 'text-ratp-anis',
  RATP_TURQUOISE = 'text-ratp-turquoise',
  /* Deuxième rangée */
  RATP_ROSE_CLAIR = 'text-ratp-rose-clair',
  RATP_ORANGE_CLAIR = 'text-ratp-orange-clair',
  RATP_MENTHE = 'text-ratp-menthe',
  RATP_VERT = 'text-ratp-vert',
  RATP_SAPIN = 'text-ratp-sapin',
  /* Troisième rangée */
  RATP_ROSE_FONCE = 'text-ratp-rose-fonce',
  RATP_FRAMBOISE = 'text-ratp-framboise',
  RATP_ORANGE_FONCE = 'text-ratp-orange-fonce',
  RATP_PRALINE = 'text-ratp-praline'
}

export interface FreeModeItem {
  id: string
  image: string
  link: string
  bgColor: BgTwColor
  textColor: TextTwColor
  shadowColor: BgTwColor
  rounded?: boolean
}

export interface Keyword {
  id: KeywordId
  twColor?: string
  bgColor?: BgTwColor
  textColor?: TextTwColor
  images?: string[]
}

interface Element {
  id: string
  description?: string
  image: string
  bgColor: BgTwColor
  textColor?: TextTwColor
  shadowColor?: BgTwColor
  rounded?: boolean
}

export interface Skill extends Element {
  id: SkillId
  keywords?: KeywordId[]
}

export interface Subsidiary extends Element {
  id: SubsidiaryId
}

export interface Option {
  id: number
  value: string
  image?: string
}

export interface QuizQuestion {
  id: string
  type: 'single' | 'multiple' | 'touch'
  image?: string
}

export interface SingleQuizQuestion extends QuizQuestion {
  type: 'single'
  options: Option[]
  goodOptionId: number
}

export interface MultipleQuizQuestion extends QuizQuestion {
  type: 'multiple'
  options: Option[]
  goodOptionsIds: number[]
}

export interface TouchQuizQuestion extends QuizQuestion {
  type: 'touch',
  zone: {
    x: number
    y: number
    width: number
    height: number
  }
}

export type Quiz = (SingleQuizQuestion | MultipleQuizQuestion | TouchQuizQuestion)[]